<template>
  <base-section
  id="keynotes"
  >
    <v-container>
    <base-section-heading
    title="Keynotes"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
You can find below the information about the Keynotes of DDECS2025.
<br>
</strong>
</base-section-heading>
<div
  v-for="talk in talks"
  :key="talk.typeTalk"
>
<base-section-heading
:title="talk.typeTalk"
color="secondary"
align="left"
:toColor="true"
>
<div
v-for="subtalk in talk.subTalks"
:key="subtalk.talkTitle"
>
<enhanced-profile-card
  v-bind="subtalk"
  />
</div>
</base-section-heading>
</div>
    </v-container>
  </base-section>
</template>

<script>
import EnhancedProfileCard from "@/components/base/EnhancedProfileCard.vue"

export default {
    name: 'Keynotes',
    components: {
      EnhancedProfileCard,
    },
    data: () => ({
      talks: [
        {
            typeTalk: "Keynote Talk",
            subTalks: [
              {
                profileImage: require('@/images/talks/sekanina.jpg'),
                profileName: "Lukas Sekanina",
                profileSubtitle: "Brno University of Technology, Czech Republic",
                talkTitle: "Evolutionary Machine Learning in Electronic Design Automation",
                abstract: "TBA",
                bio: "TBA",
              },
            ],
        },
      ],
    }),
};
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
.v-card, .v-card__title {
  word-break: unset !important;
  letter-spacing: unset !important;
  text-align: justify !important;
}
</style>
